import { render, staticRenderFns } from "./Teaser.vue?vue&type=template&id=2dae7fa0&scoped=true"
import script from "./Teaser.vue?vue&type=script&lang=js"
export * from "./Teaser.vue?vue&type=script&lang=js"
import style0 from "./Teaser.vue?vue&type=style&index=0&id=2dae7fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dae7fa0",
  null
  
)

export default component.exports